import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloud, faStore } from '@fortawesome/pro-regular-svg-icons';
import Tooltip from 'rc-tooltip';
import {
  ENUM_DELIVERY_TYPE,
  TRANSLATE_DELIVERY_TYPE,
} from '@/_features/deliveries/constants';
import styles from './delivery-type-icon.module.scss';

const ICON_BY_DELIVERY_TYPE = {
  [ENUM_DELIVERY_TYPE.CLOUD]: faCloud,
  [ENUM_DELIVERY_TYPE.LINKED]: faStore,
};

const DESCRIPTION_BY_DELIVERY_TYPE = {
  [ENUM_DELIVERY_TYPE.CLOUD]: 'Atendida pelos entregadores da nuvem',
  [ENUM_DELIVERY_TYPE.LINKED]: 'Atendida pelos entregadores do estabelecimento',
};

interface DeliveryTypeIconProps {
  deliveryType?: ENUM_DELIVERY_TYPE;
}

export function DeliveryTypeIcon({ deliveryType }: DeliveryTypeIconProps) {
  if (!deliveryType) {
    return null;
  }

  const label = `Entrega ${TRANSLATE_DELIVERY_TYPE[
    deliveryType
  ].toLowerCase()}`;

  return (
    <Tooltip
      overlay={
        <span className={styles.tooltip}>
          <b>{label}</b>
          {DESCRIPTION_BY_DELIVERY_TYPE[deliveryType]}
        </span>
      }
      placement="top"
      mouseEnterDelay={0.2}
      overlayClassName="white-tooltip"
    >
      <span
        className={styles.icon}
        aria-label={`${label}: ${DESCRIPTION_BY_DELIVERY_TYPE[deliveryType]}`}
        role="img"
      >
        <FontAwesomeIcon icon={ICON_BY_DELIVERY_TYPE[deliveryType]} />
      </span>
    </Tooltip>
  );
}
